<template>
	<span class="age">
		{{value}} {{typeName}}
	</span>
</template>

<script>
export default {
	name: 'Age',
	props: {
		value: { type: Number },
		type: { type: String, default: 'A' }
    },
	computed: {
		typeName() {
			if (this.type === 'A') {
				if (this.value > 1) {
					return 'ans'
				} else {
					return 'an'
				}
			}

			if (this.type === 'J') {
				if (this.value > 1) {
					return 'jours'
				} else {
					return 'jour'
				}
			}

			if (this.type === 'M') {
				return 'mois'
			}
		}
	}
};
</script>
